/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const PP_PREFIX = 'PARKPASS_';

// --- Facilities
export const FETCH_FACILITIES = `${PP_PREFIX}FETCH_FACILITIES`;
export const RESET_FACILITIES = `${PP_PREFIX}RESET_FACILITIES`;
export const FETCH_FACILITY = `${PP_PREFIX}FETCH_FACILITY`;
export const FETCH_FACILITY_BY_ID_OR_SLUG = `${PP_PREFIX}FETCH_FACILITY_BY_ID_OR_SLUG`;

// --- Pass Types
export const FETCH_PASS_TYPES = `${PP_PREFIX}FETCH_PASS_TYPES`;
export const RESET_PASS_TYPES = `${PP_PREFIX}RESET_PASS_TYPES`;

export const FETCH_PASS_TYPE = `${PP_PREFIX}FETCH_PASS_TYPE`;
export const RESET_PASS_TYPE = `${PP_PREFIX}RESET_PASS_TYPE`;

// --- Reservations
export const FETCH_RESERVATIONS = `${PP_PREFIX}FETCH_RESERVATIONS`;
export const CREATE_RESERVATIONS = `${PP_PREFIX}CREATE_RESERVATIONS`;
export const UPDATE_RESERVATION = `${PP_PREFIX}UPDATE_RESERVATION`;
export const DELETE_RESERVATION = `${PP_PREFIX}DELETE_RESERVATION`;
export const RESET_RESERVATIONS = `${PP_PREFIX}RESET_RESERVATIONS`;

// --- Passes
export const GET_QR_CODES_SUCCESS = `${PP_PREFIX}GET_QR_CODES_SUCCESS`;
export const GET_QR_CODES_ERROR = `${PP_PREFIX}GET_QR_CODES_ERROR`;

export const VALIDATE_RESERVATIONS = `${PP_PREFIX}VALIDATE_RESERVATIONS`;
export const VALIDATE_RESERVATIONS_CLEAR = `${PP_PREFIX}VALIDATE_RESERVATIONS_CLEAR`;

// --- Local Reservation
export const ADD_LOCAL_RESERVATION = `${PP_PREFIX}ADD_RESERVATION`;
export const DELETE_LOCAL_RESERVATION = `${PP_PREFIX}DELETE_LOCAL_RESERVATION`;
